// Українська — mirrors en.js key for key. uk uses the CLDR categories
// one/few/many (other for fractions); the plural strings below carry all of
// them. Polaris has no Ukrainian UI file, so its component internals fall
// back to English (see ../polaris.js) — our own strings are unaffected.
const uk = {
  // ===== shared =====
  'common.createPlan': 'Створити план',
  'common.save': 'Зберегти',
  'common.cancel': 'Скасувати',
  'common.delete': 'Видалити',
  'common.edit': 'Редагувати',
  'common.retry': 'Спробувати знову',
  'common.activate': 'Активувати',
  'common.deactivate': 'Деактивувати',
  'common.enabled': 'Увімкнено',
  'common.disabled': 'Вимкнено',
  'common.viewTerms': 'Переглянути умови',
  'common.untitledPlan': 'План без назви',
  'common.savedToast': 'Успішно збережено',

  // ===== nav / chrome =====
  'nav.home': 'Головна',
  'nav.plans': 'Плани',
  'nav.settings': 'Налаштування',

  'mismatch.title': 'Невідповідність середовища розгортання',
  'mismatch.body': 'Ця збірка фронтенду звертається до {apiBase}, але її обслуговує {hostname} (очікувалося: {expected}).',
  'mismatch.contact': 'Зверніться до технічної підтримки — це помилка конфігурації розгортання, а не проблема з вашим обліковим записом.',

  'install.title': 'Не вдалося з’єднатися з Shopify',
  'install.body': 'Перевірте, чи працює бекенд і чи збігається його SHOPIFY_API_KEY із client_id застосунку у shopify.app.toml.',
  'install.retry': 'Спробувати знову',

  'chrome.loadingBrand': 'FlexCover завантажується…',
  'error.title': 'Щось пішло не так',
  'error.reload': 'Перезавантажити',

  'support.badge': 'Режим підтримки',
  'support.shopUnknown': '(невідомий магазин)',
  'support.expired': 'Термін дії токена минув — згенеруйте новий у консолі підтримки',
  'support.validUntil': 'Токен діє до {time}',
  'support.exit': 'Вийти',

  // ===== Home =====
  'home.title': 'Вітаємо у FlexCover: Protection Plans 👋',
  'home.last30days': 'Останні 30 днів',
  'home.loadingChart': 'Графік завантажується',
  'home.loadingOverview': 'Огляд завантажується',
  'home.statOrders': 'Замовлення з планами',
  'home.statRevenue': 'Загальний дохід від планів',
  'home.gettingStarted': 'Початок роботи',
  'home.allSet': 'Усе готово 🎉',
  'home.completed': 'Виконано {done} із {total}',
  'home.step1.title': 'Створіть свій перший план',
  'home.step1.desc': 'Укажіть ціну, покриття та вигляд у кошику для вашої пропозиції захисту.',
  'home.step2.title': 'Увімкніть вбудований блок застосунку',
  'home.step2.desc': 'Увімкніть блок FlexCover: Protection Plans, щоб віджет з’явився у вашому кошику.',
  'home.step2.enable': 'Увімкнути блок застосунку',
  'home.step2.check': 'Перевірити стан',
  'home.step3.title': 'Отримайте перше захищене замовлення',
  'home.step3.desc': 'Коли віджет запрацює, клієнти зможуть додати план у кошику — підсумки з’являться на картках вище.',
  'home.appEmbed': 'Вбудований блок застосунку',
  'home.checkingEmbed': 'Перевірка стану вбудованого блоку',
  'home.embedEnabledBody': 'Віджет захисту працює у вашій вітрині.',
  'home.embedTheme': '(тема: {theme})',
  'home.embedDisabledBody': 'Застосунок зараз не активний у вашій вітрині.',
  'home.embedUnknown': 'Невідомо',
  'home.embedUnknownBody': 'Стан вітрини буде доступний, щойно застосунок буде з’єднано з магазином.',
  'home.embedUnknownReason': 'Наразі не вдалося прочитати вашу активну тему.',
  'home.enableEmbedHint': 'В адмінпанелі Shopify відкрийте Online Store → Themes → Customize → App embeds і увімкніть FlexCover: Protection Plans.',
  'home.learnMorePrefix': 'Докладніше про ',
  'home.learnMoreLink': 'використання планів захисту',

  // ===== Plans list =====
  'plans.title': 'Плани',
  'plans.loading': 'Завантаження планів',
  'plans.errorTitle': 'Не вдалося завантажити плани',
  'plans.empty.heading': 'Створіть свій перший план захисту',
  'plans.empty.body': 'Пропонуйте захист доставки, подовжені гарантії, страхування повернення та власне покриття — з цінами, які визначаєте ви.',
  'plans.loadDemo': 'Завантажити демоплани',
  'plans.demoLoaded': 'Демоплани завантажено',
  'plans.demoFailed': 'Не вдалося завантажити демоплани: {message}',
  'plans.filterPlaceholder': 'Фільтрувати плани',
  'plans.addFilter': 'Додати фільтр',
  'plans.statusHeading': 'Стан',
  'plans.typeHeading': 'Тип захисту',
  'plans.statusActive': 'Активний',
  'plans.statusInactive': 'Неактивний',
  'plans.showing_one': 'Показано {count} план',
  'plans.showing_few': 'Показано {count} плани',
  'plans.showing_many': 'Показано {count} планів',
  'plans.showing_other': 'Показано {count} плану',
  'plans.sortBy': 'Сортувати за',
  'plans.selectAll': 'Вибрати всі плани',
  'plans.selectedCount': 'Вибрано {count}',
  'plans.bulkDeleted_one': '{count} план видалено',
  'plans.bulkDeleted_few': '{count} плани видалено',
  'plans.bulkDeleted_many': '{count} планів видалено',
  'plans.bulkDeleted_other': '{count} плану видалено',
  'plans.bulkActivated_one': '{count} план активовано',
  'plans.bulkActivated_few': '{count} плани активовано',
  'plans.bulkActivated_many': '{count} планів активовано',
  'plans.bulkActivated_other': '{count} плану активовано',
  'plans.bulkDeactivated_one': '{count} план деактивовано',
  'plans.bulkDeactivated_few': '{count} плани деактивовано',
  'plans.bulkDeactivated_many': '{count} планів деактивовано',
  'plans.bulkDeactivated_other': '{count} плану деактивовано',
  'plans.deleteBulkFailed': 'Не вдалося видалити: {message}',
  'plans.updateBulkFailed': 'Не вдалося оновити: {message}',
  'plans.activated': 'План активовано',
  'plans.deactivated': 'План деактивовано',
  'plans.updateFailed': 'Не вдалося оновити план: {message}',
  'plans.deleted': 'План видалено',
  'plans.deleteFailed': 'Не вдалося видалити план: {message}',
  'plans.actionsFor': 'Дії для {name}',
  'plans.activatePlan': 'Активувати {name}',
  'plans.deactivatePlan': 'Деактивувати {name}',
  'plans.onlineStore': 'Інтернет-магазин',
  'plans.optional': 'Необов’язковий',
  'plans.automatic': 'Автоматичний',
  'plans.noMatch': 'Немає планів, що відповідають вашому пошуковому запиту чи фільтрам.',
  'plans.deleteTitle': 'Видалити план захисту?',
  'plans.deleteBody': 'буде негайно вилучено з вашого магазину. Клієнти більше не побачать цю опцію захисту.',
  'plans.helpPrefix': 'Потрібна допомога? ',
  'plans.helpLink': 'Напишіть нам',
  'plans.helpSuffix': ' або перегляньте документацію та посібники застосунку.',

  'sort.date': 'Дата (спочатку новіші)',
  'sort.name': 'Назва (А–Я)',
  'sort.sortOrder': 'Порядок у кошику',
  'sort.price': 'Ціна (за зростанням)',

  'planType.shipping_protection': 'Захист доставки',
  'planType.warranty': 'Гарантія',
  'planType.return_insurance': 'Страхування повернення',
  'planType.custom': 'Власний захист',
  'planTypeShort.shipping_protection': 'Доставка',
  'planTypeShort.warranty': 'Гарантія',
  'planTypeShort.return_insurance': 'Повернення',
  'planTypeShort.custom': 'Власний',
  'priceType.fixed': 'Фіксована сума',
  'priceType.percentage': 'Відсоток від замовлення',

  // ===== Plan editor page shell =====
  'plan.pageTitle': 'План захисту',
  'plan.loading': 'Завантаження плану',
  'plan.notFound.heading': 'План не знайдено',
  'plan.notFound.body': 'Можливо, цей план захисту було видалено.',
  'plan.backToPlans': 'Назад до планів',
  'plan.newTitle': 'Новий план захисту',
  'plan.newSubtitle': 'Налаштуйте ціни та вигляд у кошику, потім створіть план',
  'plan.subtitle': 'Зміни набудуть чинності у вашому магазині після збереження',
  'plan.statusTitle': 'Стан плану',
  'plan.saveFailed': 'Не вдалося зберегти план: {message}',

  // ===== Plan editor form =====
  'form.section.type': 'Тип захисту',
  'form.section.basics': 'Основні дані плану',
  'form.section.pricing': 'Ціни — {type}',
  'form.pricingFallback': 'Захист',
  'form.section.appearance': 'Вигляд',
  'form.section.fulfillment': 'Виконання',

  'form.type.shipping_protection': 'Захист доставки',
  'form.type.shipping_protection.help': 'Захищає замовлення клієнта від втрати, пошкодження чи крадіжки під час доставки.',
  'form.type.warranty': 'Гарантія',
  'form.type.warranty.help': 'Покриває виробничі дефекти та природний знос протягом визначеного строку.',
  'form.type.return_insurance': 'Страхування повернення',
  'form.type.return_insurance.help': 'Дозволяє клієнтам повертати товари протягом строку з повним відшкодуванням.',
  'form.type.custom': 'Власний захист',
  'form.type.custom.help': 'Ваше власне повідомлення про покриття.',

  'form.defaults.untitledPlan': 'План без назви',
  'form.defaults.viewTerms': 'Переглянути умови',
  'form.defaults.shipping_protection.displayName': 'Захист доставки',
  'form.defaults.shipping_protection.description': 'Захистіть своє замовлення від втрати, пошкодження та крадіжки під час доставки.',
  'form.defaults.warranty.displayName': 'Подовжена гарантія',
  'form.defaults.warranty.description': 'Покриває виробничі дефекти та природний знос протягом 2 років.',
  'form.defaults.return_insurance.displayName': 'Страхування повернення',
  'form.defaults.return_insurance.description': 'Поверніть будь-який товар протягом 14 днів з повним відшкодуванням.',
  'form.defaults.custom.displayName': 'План захисту',
  'form.defaults.custom.description': 'Додайте захист до свого замовлення.',

  'form.lang.select': 'Вибрати мову',
  'form.lang.default': '{name} (типово)',
  'form.translated': '(перекладено)',

  'form.field.planName.label': 'Назва плану (внутрішня)',
  'form.field.planName.help': 'Лише для вашого орієнтування — клієнти цього ніколи не бачать',
  'form.field.nameRequired': 'Внутрішня назва обов’язкова',
  'form.field.displayName.label': 'Публічна назва',
  'form.field.displayNameRequired': 'Публічна назва обов’язкова',
  'form.field.displayName.placeholder': 'Публічна назва',
  'form.field.displayName.help': 'Показується клієнтам у кошику та на оформленні замовлення',
  'form.field.displayName.helpPreset': 'Показується клієнтам, які переглядають {lang}',
  'form.field.displayName.helpPresetFallback': 'Показується клієнтам, які переглядають {lang} — порожні поля звертаються до {primary}',
  'form.field.description.label': 'Опис',
  'form.field.description.placeholder': 'Опис',
  'form.field.description.help': 'Короткий опис для клієнтів під назвою плану',
  'form.field.disabledDescription.label': 'Опис для невибраного стану',
  'form.field.disabledDescription.placeholder': 'Необов’язково — показується, коли план не вибрано',
  'form.field.disabledDescription.help': 'Показується, коли прапорець плану знято (якщо порожньо, використовується опис вище)',
  'form.field.footer.label': 'Нижній колонтитул',
  'form.field.footerText.label': 'Текст колонтитула',
  'form.field.footerLink.label': 'Посилання колонтитула',
  'form.field.footerLink.help': 'Куди веде посилання з тексту колонтитула',

  'form.price.type.label': 'Тип ціни',
  'form.price.fixed': 'Сума ($)',
  'form.price.percentage': 'Відсоток (%)',
  'form.price.advanced': 'Розширене налаштування',
  'form.price.pctSummary': '{pct}% від суми замовлення, від ${min} з кроком ${inc} до ${max} — {count} варіантів у товарі плану',
  'form.price.tiersSummary_one': 'Товар плану отримує 1 варіант за {base} плюс {count} інтервальний варіант для правил вартості кошика',
  'form.price.tiersSummary_few': 'Товар плану отримує 1 варіант за {base} плюс {count} інтервальні варіанти для правил вартості кошика',
  'form.price.tiersSummary_many': 'Товар плану отримує 1 варіант за {base} плюс {count} інтервальних варіантів для правил вартості кошика',
  'form.price.tiersSummary_other': 'Товар плану отримує 1 варіант за {base} плюс {count} інтервального варіанта для правил вартості кошика',

  'form.validation.priceRequired': 'Введіть значення більше за 0',
  'form.validation.priceMax100': 'Відсоток не може перевищувати 100',
  'form.validation.warrantyYears': 'Введіть строк від 1 до 5 років',
  'form.validation.returnDays': 'Введіть строк від 7 до 365 днів',
  'form.validation.maxGreaterThanMin': 'Максимум має бути більшим за мінімум',
  'form.validation.variantIdNumeric': 'ID варіанта має бути числовим (ID прихованого варіанта плану)',

  'form.icon.label': 'Піктограма',
  'form.icon.useEmoji': 'Використати {emoji} як піктограму плану',
  'form.icon.removeCustom': 'Вилучити власну піктограму та використати піктограму щита',
  'form.icon.upload': 'Завантажити власне зображення піктограми',
  'form.icon.uploadButton': 'Завантажити',
  'form.icon.uploading': 'Піктограма завантажується',
  'form.icon.uploadHelp': 'Завантажте власну піктограму — PNG, JPEG, GIF або WebP, до 5 МБ.',
  'form.icon.error.notImage': 'Виберіть файл зображення (PNG, JPEG, GIF або WebP).',
  'form.icon.error.tooLarge': 'Зображення має бути не більшим за 5 МБ.',

  'form.fulfillment.intro': 'Виберіть, коли товар захисту позначається як виконаний.',
  'form.fulfillment.manually': 'Виконувати вручну',
  'form.fulfillment.first_item': 'Позначати виконаним, коли виконано перший товар у замовленні',
  'form.fulfillment.all_items': 'Позначати виконаним, коли виконано всі інші товари в замовленні',
  'form.fulfillment.immediately': 'Позначати виконаним одразу після створення замовлення',

  'form.adv.title': 'Розширене налаштування',
  'form.adv.minPrice': 'Мінімальна ціна',
  'form.adv.minPriceHelp': 'Ціна першого варіанта — найменша плата за планом',
  'form.adv.increment': 'Крок збільшення',
  'form.adv.incrementHelp': 'Крок ціни між створеними варіантами',
  'form.adv.maxPriceLabel': 'Максимальна ціна: ',
  'form.adv.explanation': 'Товар плану створюється з {buckets} варіантів: мінімальна ціна {min} займає один варіант, а решта {rest} варіантів зростають з кроком {inc} до максимальної ціни {max}. При оформленні клієнт платить перший варіант із ціною, що дорівнює чи перевищує {pct}% підсумку кошика — кошик $100 за 2% дає ціль $2.00, тож застосовується варіант $3.01. ',
  'form.learnMore': 'Докладніше',

  'form.tiers.title': 'Установити ціну за вартістю кошика',
  'form.tiers.minCol': 'Мінімальна вартість кошика',
  'form.tiers.maxCol': 'Максимальна вартість кошика',
  'form.tiers.priceCol': 'Ціна захисту',
  'form.tiers.addTier': 'Додати нове правило',
  'form.tiers.deleteTier': 'Видалити правило {index}',
  'form.tiers.explanation': 'Кожне правило потребує мінімуму, максимуму та ціни (правила можуть перетинатися — застосовується перше відповідне правило). Кожне правило стає окремим варіантом у товарі плану. Якщо сума кошика не відповідає жодному правилу, застосовується фіксована ціна з основного налаштування. ',
  'form.tiers.error.minRequired': 'Потрібна мінімальна вартість кошика',
  'form.tiers.error.maxRequired': 'Потрібна максимальна вартість кошика',
  'form.tiers.error.priceRequired': 'Потрібна ціна захисту',
  'form.tiers.error.pricePositive': 'Ціна має бути більшою за 0',
  'form.tiers.error.minMax': 'Мінімум має бути не більшим за максимум',

  // ===== Save bar =====
  'savebar.unsavedChanges': 'Є незбережені зміни',
  'savebar.discard': 'Відкинути',
  'savebar.saving': 'Збереження…',

  // ===== Preview panel =====
  'preview.title': 'Перегляд',
  'preview.simulatedSubtotal': 'Імітований підсумок кошика',
  'preview.cart': 'Кошик',
  'preview.product': 'ТОВАР',
  'preview.total': 'РАЗОМ',
  'preview.subtotal': 'Підсумок',
  'preview.checkout': 'Оформити замовлення',
  'preview.noPlans': 'Ще немає активних планів — клієнти не побачать цей віджет.',
  'preview.autoAdded': 'Додано автоматично',
  'preview.unsaved': 'Не збережено',

  // ===== Settings page =====
  'settings.title': 'Налаштування',
  'settings.language.title': 'Мовні параметри',
  'settings.language.help': 'Коли ви відкриваєте FlexCover, це мова, якою вам показують інтерфейс. Мова вашого магазину не змінюється.',
  'settings.language.label': 'Мова',
  'settings.language.updated': 'Мову оновлено',
  'settings.language.saveFailed': 'Не вдалося зберегти мовні параметри: {message}'
};

export default uk;
